<template>
  <div class="message">
    <div class="loading" v-if="!isLoadingEnd">
      <img src="./../../assets/takingCar/loading.gif" alt="" />
    </div>
    <div v-if="isLoadingEnd">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <div class="oilList">
              <div class="con" @click="Detail(item.id)">
                <span class="circle" v-if="item.read_status == 0"></span>
                <p class="title">{{ item.title }}</p>
                <p class="time">{{ item.updated_at }}</p>
                <div class="tip">查看详情</div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-row class="empty" v-if="list.length == 0">
        <van-col class="emptyMsg" span="24">
          <img src="../../assets/member/nomessage.png" />
          <p class="tip1">暂无公告消息</p>
          <p class="tip2">返回上一级去逛逛吧</p>
          <p class="btn"><span @click="goBack()">上一级</span></p>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import defaultImg from "@/assets/common/ListPreload.png";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      msgId: 0,
      isLoadingEnd: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.getInfo();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    Detail(id) {
      this.msgId = id;
      this.goToSeeNoticeDetail();
    },
    goToSeeNoticeDetail() {
      this.params(this.msgId, this.msgId, "goToSeeNoticeDetail");
    },
    getInfo() {
      this.$api
        .post("/cms/member/notice/message/noticeMsgList", {
          pageSize: this.pageSize,
          page: this.page,
        })
        .then((res) => {
          this.isLoadingEnd = true;
          this.allList = res.total;
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //		    this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>

<style lang="less">
.message {
  padding: 0 12px;
  background: #f2f2f2;
  height: 100%;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .van-pull-refresh {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .empty {
    padding-top: 132px;
    .emptyMsg {
      padding: 0 47px;
      text-align: center;
      img {
        width: 100%;
        display: block;
      }
      .tip1 {
        color: #333;
        font-size: 13px;
        margin-top: 40px;
        height: 26px;
        line-height: 26px;
      }
      .tip2 {
        color: #666;
        font-size: 11px !important;
        height: 24px;
        line-height: 24px;
        margin-bottom: 23px;
      }
      .btn {
        text-align: center;
        span {
          width: 110px;
          height: 32px;
          line-height: 32px;
          color: #ff6059;
          display: inline-block;
          border: solid 1px #ff6059;
          border-radius: 16px;
          box-shadow: rgba(255, 96, 89, 0.14) 3px 0 6px;
        }
      }
    }
  }

  .van-cell {
    padding: 0;
    background: #f5f6f7;
    .oilList {
      .con {
        background: #fff;
        padding: 12px;
        border-radius: 5px;
        position: relative;
        text-align: center;
        margin-top: 9px;
        .circle {
          width: 9px;
          height: 9px;
          display: inline-block;
          background: #f41a3c;
          border-radius: 4px;
          position: absolute;
          top: 8px;
          right: 9px;
        }
        .title {
          color: #333;
          font-size: 18px;
          line-height: 29px;
          font-weight: bold;
        }
        .time {
          height: 19px;
          line-height: 19px;
          font-size: 12px;
          color: #999;
          margin-top: -3px;
        }
        .tip {
          color: #f9591b;
          font-size: 14px;
          height: 23px;
          line-height: 23px;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
